/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';
import config from '../../common/config';
import Request from '../fw/Request';

import Editor from '../fw/Editor.react';
import urlMapping from '../app/URLMapping';
import {injectIntl, defineMessages, FormattedMessage, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import './Invitations.scss';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'invitationAdd.title', 'defaultMessage': 'Invite new user'},
    sent: {id: 'invitationAdd.sent', defaultMessage: 'Sent'},
    sending: {id: 'invitationAdd.sending', defaultMessage: 'Sending'},
    sendInvitation: {id: 'invitationAdd.sendInvitation', defaultMessage: 'Send Invitation'},
});

interface InvitationAddProps {
 intl: IntlShape;
 user: User;
}

class InvitationAdd extends React.Component<InvitationAddProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.state = {
            alreadyExists: false
        };
    }

    typeName = 'invitations';

    onBeforeSubmit(data) {
        let query = Relay.QL`query {
            me {
                organisation(id: $organisationId) {
                    invitations(email: $email, first: 10) {
                        edges {
                            node {
                                id,
                                realId,
                                email,
                                createdAt,
                                organisation_id,
                            }
                        }
                    },
                    organisations2user(first: 2000) {
                        edges {
                            node {
                                id,
                                realId,
                            }
                        }
                    },
                    adminUsers(first: 200) {
                        edges {
                            node {
                                id,
                                realId,
                            }
                        }
                    },
                    users(first: 200) {
                        edges {
                            node {
                                id,
                                realId,
                            }
                        }
                    }
                }
            }
        }`;

        let params = {
            organisationId: this.props.user.organisation.realId,
            email: data.email
        };

        return Request(query, params).then((data) => {
            if (data.me.organisation.invitations && data.me.organisation.invitations.edges && data.me.organisation.invitations.edges.length > 0) {
                this.setState({
                    alreadyExists: true,
                    alreadyExistsEmail: params.email
                });
                return Promise.reject();
            }

            this.setState({
                alreadyExists: false,
                alreadyExistsEmail: ''
            });
            return Promise.resolve();
        });
    }

    render() {
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation}
            ]} className="invitationScreen" title={this.props.intl.formatMessage(messages.title)}>
                <p><FormattedMessage defaultMessage="By inviting user you will allow access to your integrations in {productName}." id="invitationAdd.explanationWithoutOrg" values={{productName: config.PRODUCT_NAME}}/></p>

                {this.state.alreadyExists
                    ? <p className="error"><FormattedMessage defaultMessage="Invitation to {email} already exists." id="invitationAdd.explanationWithoutOrg3" values={{email: this.state.alreadyExistsEmail}}/></p>
                    : null
                }

                <Editor
                    columns={['email', 'role']}
                    enableDisable
                    fatQuery={Relay.QL `fragment on CreateInvitationPayload @relay(pattern: true) {
                        edge {
                            node {
                                id,
                                organisation_id,
                            }
                        },
                        organisation {
                            id,
                            invitations(first: 100) {
                                edges {
                                    node {
                                        id,
                                    }
                                }
                            },
                            users(first: 200) {
                                edges {
                                    node {
                                        id,
                                    }
                                }
                            }
                        }
                    }`}
                    isCreate
                    metadata={type}
                    mutation={Relay.QL `mutation { createInvitation }`}
                    onBeforeSubmit={this.onBeforeSubmit.bind(this)}
                    onSuccess={() => {
                        let path = urlMapping.getUrl('organisation2user', 'list', this.props.user.organisation);
                        this.context.router.push(path);
                    }}
                    organisationId={this.props.user.organisation.realId}
                    parent={this.props.user.organisation}
                    submitLoadingButtonNewConfig={{
                        doneText: this.props.intl.formatMessage(messages.sent),
                        icon: 'fa-envelope-o',
                        progressText: this.props.intl.formatMessage(messages.sending),
                        text: this.props.intl.formatMessage(messages.sendInvitation),
                    }}
                    urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(InvitationAdd), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                }
            }
        `,
    },
});
